import { TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE } from '../shared/abstract-boxes';

export function AiConnectorBoxViewConstructor(services, callbacks, context, siteTypeConfig) {
  let joint = services.joint;

  return joint.shapes.html.AbstractBoxElementWithDragAndDropView.extend({
    isElementEditable: true,
    editElementModalController: [
      '$scope',
      '$mdDialog',
      'elementData',
      ($scope, $mdDialog, elementData) => {
        $scope.elementData = elementData;
        $scope.cancelDialog = $mdDialog.cancel;
        $scope.hideDialog = $mdDialog.hide;
      },
    ],
    editElementModalTemplate: `<angular-ai-connector
      [element-data]="elementData"
      (hide-dialog)="hideDialog($event)"
      (cancel-dialog)="cancelDialog()"
      ></angular-ai-connector>`,
    angularTemplate: require('./ai-connector-box.view.html'),

    initialize: function () {
      joint.shapes.html.AbstractBoxElementWithDragAndDropView.prototype.initialize.apply(this, arguments);
      this.updateValidity();
    },

    afterEditElement: function () {
      if (this.angularScope.elementData.subBotDescription.exits) {
        let currentExits = this.model
          .getEmbeddedCells()
          .filter(exitCell => exitCell.get('elementData').exitType !== 'failure');

        // exits are always the same (not like a subbot which can change)
        if (currentExits.length === 0) {
          const newExits = this.angularScope.elementData.subBotDescription.exits;
          services.QuickRepliesFactory.createUniqueIds(
            context.companyId,
            context.site.id,
            context.scenarioId,
            newExits.length
          ).then(response => {
            const ids = response.data.map(element => element.id);
            let index = 0;
            newExits.forEach(exitDescription => {
              const exitElementData = {
                exitType: 'success',
                name: exitDescription.name,
                description: exitDescription.description,
              };
              const exit = this.createExit(ids[index++], TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE, exitElementData);
              this.model.graph.addCell(exit);
            });
            if (this.reorderChildren) {
              this.reorderChildren();
            }
          }, services.AlertingFactory.httpErrorHandler());
        }
      }
      this.updateValidity();
    },

    updateValidity: function () {
      if (this.angularScope.elementData.parameters) {
        this.angularScope.isValid = true;
        this.model.setBoxValid(true);
      } else {
        this.angularScope.isValid = false;
        this.model.setBoxValid(false);
      }
    },

    createExit: function (id, position, size, elementData) {
      const exit = new joint.shapes.html.AiConnectorExit({ id, position, size, elementData });
      this.model.embed(exit);
      return exit;
    },

    isChildAlwaysLast: function (child) {
      return child.get('elementData')?.exitType === 'failure';
    },
  });
}
